export const getRedirectUrl = () => {
  const url = window.location.href
  const parsedUrl = new URL(url)
  return parsedUrl.searchParams.get('redirectUrl')
}
